import { Component, h, Prop, Listen } from "@stencil/core"
import { Fragment } from "@stencil/core"
import SearchResult from "./SearchResult"
@Component({
  tag: "ai12z-category",
  styleUrls: ["../ai12z-cta.css", "../../../global/tailwind.min.css"],
  shadow: true,
  //   scoped:true
})
export class Category {
  @Prop({ reflect: true }) categoryList: any
  @Prop({ reflect: true }) linkTarget: string
  categories: any = {}

  @Listen("clearResults", { target: "document" })
  clearResultsHandler(_state) {
    this.categories = {}
  }

  componentShouldUpdate() {
    // console.log("componentShouldUpdate", this.categoryList)
    if (this.categoryList && this.categoryList.length > 0) {
      /*group by category*/
      let grouped = this.categoryList.reduce((result: any, currentValue: any) => {
        ;(result[currentValue["category"]] = result[currentValue["category"]] || []).push(currentValue)
        return result
      }, {})

      this.categories = grouped
    } else {
      this.categories = {}
    }
  }

  render() {
    return Object.entries(this.categories).map(([key, value], _index) => {
      return (
        <Fragment>
          <div>
            <h1 class="custom-title">{key}</h1>
          </div>
          <SearchResult results={value} linkTarget={this.linkTarget} />
        </Fragment>
      )
    })
  }
}
